import styled from "@emotion/styled";
import CardCTA from "components/CardCTA";
import InterestFormModal from "components/InterestForm/InterestFormModal";
import Layout from "components/Layout";
import Partners from "components/Partners/Partners";
import USP from "components/USP";
import Image from "next/image";
import { ReactElement, useState } from "react";
import { Button, colors } from "ui";

import bousp1 from "../assets/images/bousp1.png";
import bousp2 from "../assets/images/bousp2.png";
import productImg2 from "../assets/images/productImg2.png";
import rebornProducts from "../assets/images/reborn-products.png";

const BACKOFFICE_CTA = [
  {
    img: bousp1,
    title: "Sublyfe system",
    text: "Sublyfe Backoffice kopplar smidigt din salong till vår prenumerationstjänst.",
    bottomText: "499kr/mån",
  },
  {
    img: bousp2,
    title: "Licenser per användare",
    text: "Sublyfe låter dig effektivt hantera kundprenumerationer.",
    bottomText: "49kr per användare/mån",
  },
];

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  h1 {
    text-align: center;
    color: ${colors.blackText};
  }
`;

const Row = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 25px;
  margin-bottom: 75px;

  @media (min-width: 700px) {
    flex-direction: row;
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  p {
    letter-spacing: 1.2px;
    line-height: 22px;
    font-weight: 500;
    text-align: center;
    color: ${colors.blackText};
  }

  button {
    margin: 20px auto;
  }
`;

const BOCardWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 25px;
  margin-top: 25px;
  margin-bottom: 75px;

  @media (max-width: 700px) {
    flex-direction: column;
    align-items: center;
  }
`;

const UspText = styled.p`
  line-height: 28px !important;
  letter-spacing: 2px !important;
  font-size: 20px;
`;

const InfoCardWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 25px;

  @media (max-width: 720px) {
    flex-direction: column;
    align-items: center;
  }
`;

const InfoCard = styled.div<{ color: string }>`
  display: flex;
  flex-direction: column;
  max-width: 320px;
  margin: 10px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  border-radius: 16px;
  padding: 20px 20px 40px;

  background: ${({ color }) => color};

  h3 {
    text-align: center;
    color: ${colors.blackText};
    font-size: 20px;
  }

  i {
    margin-bottom: 26px;
  }

  strong {
    margin-bottom: 20px;
  }
`;

const Product = () => {
  const [interestForm, setInterestForm] = useState(false);

  return (
    <>
      <Wrapper>
        <h1>
          En lösning för att återvinna kundernas lojalitet och öka försäljningen
          i din salong
        </h1>
        <Row>
          <Image src={rebornProducts} alt="rebornProducts" height={400} />
          <Column>
            <p>
              Vi tror på nära samarbeten med frisörsalonger för att hjälpa öka
              deras försäljning. Genom att erbjuda unika prenumerationer baserat
              på kundens favoritprodukter och behov, hjälper vi er att bygga en
              lojal kundbas och ökad försäljning.
              <br />
              <br />
              Vi förstår att hår är en mycket personlig och viktig del av
              människans identitet och vi tror att det är frisören som har den
              bästa kunskapen och känslan för just hår.
            </p>
            <Button
              aria-label="kom igång"
              fullWidth
              onClick={() => setInterestForm(true)}
            >
              Kom igång
            </Button>
          </Column>
        </Row>
        <h1>Sublyfe Backoffice</h1>
        <BOCardWrapper>
          {BACKOFFICE_CTA.map(({ img, title, text, bottomText }) => (
            <CardCTA
              key={title}
              img={img}
              title={title}
              text={text}
              bottomText={bottomText}
            />
          ))}
        </BOCardWrapper>
        <h1>Öka din försäljning med Sublyfe</h1>
        <InfoCardWrapper>
          <InfoCard color={colors.red200}>
            <h3>Utan Sublyfe</h3>
            <i>Genomsnittliga försäljning av produkter på salong i Sverige</i>
            <strong>1.5/dag/frisör</strong>
            <strong>300st produkter/år/frisör</strong>
            <strong>Omsättning: 75.000sek/år/frisör</strong>
            <strong>Försäljningstillfällen ca. 200st/år</strong>
          </InfoCard>
          <InfoCard color={colors.green200}>
            <h3>Med Sublyfe</h3>
            <i>
              Exempel: Ökad genomsnittlig försäljning av produkter på salong med
              70%
            </i>
            <strong>2.5/dag /frisör</strong>
            <strong>500st produkter/år/frisör</strong>
            <strong>Omsättning: 125.000sek/år/frisör </strong>
            <strong>Försäljningstillfällen ca. 25st/år</strong>
          </InfoCard>
        </InfoCardWrapper>
        <Button
          aria-label="kom igång"
          onClick={() => setInterestForm(true)}
          sx={{
            width: "fit-content",
            minWidth: "250px",
            margin: "50px auto 0",
          }}
        >
          Kom igång
        </Button>
        <USP
          reverse
          img={<Image src={productImg2} alt="productImg2" height={400} />}
          content={
            <UspText>
              Vi är stolta över att samarbeta med några av de mest framstående
              salongerna i branschen och vi strävar alltid efter att leverera
              den högsta nivån av service och stöd.Vårt team består av erfarna
              och engagerade proffs som arbetar hårt för att öka tillväxten av
              din verksamhet.
            </UspText>
          }
        />
        <Partners />
      </Wrapper>
      <InterestFormModal
        open={interestForm}
        onClose={() => setInterestForm(false)}
      />
    </>
  );
};

Product.getLayout = function getLayout(page: ReactElement) {
  return <Layout>{page}</Layout>;
};

export default Product;
